export default "__VITE_ASSET__BfwudEro__"